export const getResourceUrl = (fileUrl: string = '') => {
  if (fileUrl === '') {
    return ''
  }
  const query = `?did=${phoenix.runtimeConfig.DEPLOYMENT_ID}`
  return new URL(`${fileUrl}${query}`, phoenix.runtimeConfig.RESOURCES_URL).href
}
